import cn from 'classnames/bind';

import GridHelper from './GridHelper';

import s from './Layout.module.scss';

const cx = cn.bind(s);

const Layout = ({
  children, header, footer, isShort,
}) => (
  <div className={cx('container', {
    containerShort: isShort,
  })}>
    {process.env.NEXT_PUBLIC_DEV_GRID_ENABLED && <GridHelper />}
    { header }
    <main className={cx('content')}>
      {children}
    </main>
    {footer && <div className={cx('footer')}>
      { footer }
    </div>}
  </div>

);

export default Layout;
